<template>
   <div class="doc_wrap_footer">
      <div class="doc_width_footer">
        <div class="footer_div">
            <div class="footer_l">
                <span class="mr20">中国农业科学院农业信息研究所</span>
                <span> ICP备案号：京ICP备09089781号-47</span>
            </div>
            <div class="footer_r">
                <img src="../assets/images/nyHome/nyLogo-agriknow.png" class="mr20 vam footer-logo"/>
                <img src="../assets/images/nyHome/footerImg1.png" class="vam"/>
            </div>
        </div>
      </div>
   </div>
</template>
<script>
export default {
  name: 'Footer',
};
</script>
<style lang="scss">
.doc_wrap_footer{
  min-width: 1350px;
  height: 116px;
  display: flex;
  align-items: center;
  background: #F4F4F4;
  .doc_width_footer{
      width: 1300px;
      margin: 0 auto;
      .footer_div{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: #606266;
        .mr20{
            margin-right: 20px;
        }
      }
  }
}
.footer-logo {
    height: 36px;
}
</style>